module.exports = __webpack_public_path__ + "static/img/icon_video4.180f03d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_video4.jpg
// module id = ZrE2
// module chunks = 21